<template>
  <div
    class="money"
    :style="{ color: props.color, fontWeight: bold ? 'bold' : 'normal' }"
  >
    <text
      v-if="props.prefix"
      :style="{
        fontSize: props.size - 6 + 'px',
        lineHeight: props.size - 6 + 'px',
      }"
      >￥</text
    >
    <text
      :style="{ fontSize: props.size + 'px', lineHeight: props.size + 'px' }"
    >
      {{ state.data_n }}
    </text>
    <text
      v-if="state.data_d"
      :style="{
        fontSize: props.size - 3 + 'px',
        lineHeight: props.size - 3 + 'px',
      }"
    >
      {{ "." + state.data_d }}
    </text>
    <text
      v-if="props.suffix"
      :style="{
        fontSize: props.size - 6 + 'px',
        lineHeight: props.size - 6 + 'px',
      }"
      >元
    </text>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { priceFormat } from "@/utils/format";

export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
    size: {
      type: Number,
      default: 14,
    },
    prefix: {
      //是否带前缀“￥”
      type: Boolean,
      default: true,
    },
    suffix: Boolean, //是否带后缀“元”
    format: {
      //金额是否需要格式化
      type: Boolean,
      default: true,
    },
    color: {
      //字体颜色
      type: String,
      default: "#f00",
    },
    bold: {
      //是否加粗
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const state = reactive({});
    onMounted(() => {
      if (props.format) {
        const data = priceFormat(props.value);
        const dataArr = data.split(".");
        state.data_n = dataArr[0];
        state.data_d = dataArr[1].substring(0, 2);
      } else {
        state.data_n = props.value;
      }
    });
    return { props, state };
  },
};
</script>
<style lang="scss" scoped>
.money {
  display: flex;
  width: fit-content;
  align-items: baseline;
}
</style>
